<template>
    <section class="component">
        <section class="component__header">
            <span class="component__header__title">
                {{$t('com.file.logo-settings.logo')}}
            </span>
            <section class="component__header__action">
                <button class="component__button
                               component__button--small
                               component__button--white"
                        @click="selectAvatar" v-tooltip="$t('com.file.logo-settings.logo-hint')">
                    <img src="@/assets/icons/components/edit.svg" />
                    <span class="component__button__text">{{$t('com.global.select')}}</span>
                </button>
            </section>
            <section v-if="logo != null && logo.length > 0" class="component__header__action">
                <button class="component__button
                               component__button--small
                               component__button--white"
                        @click="deleteLogo" v-tooltip="$t('com.file.logo-settings.delete-logo')">
                    <img src="@/assets/icons/components/delete.svg" />
                    <span class="component__button__text">{{$t('com.global.delete')}}</span>
                </button>
            </section>
        </section>
        <section class="avatar-info__item">
            <section class="avatar-info__item__label">{{$t('com.file.logo-settings.logo-info')}}:</section>
        </section>
        <section class="avatar-info__item2">{{$t('com.file.logo-settings.logo-size-info')}}</section>
        <section v-if="logo != null && logo.length > 0" class="component__body avatar">
            <section class="avatar__picture">
                <img :src="logo" alt="herb/logo" class="avatar__picture__img" />
            </section>
            <section class="column-item in-row" v-if="transmissionModule === 1">
                <section class="esesja-modal__row">
                    <div class="form-bootstrap-check form-bootstrap-switch">
                        <input class="form-bootstrap-check-input" type="checkbox" role="switch"
                                id="dontShowWhiteBackgroundInESesjaTvOverlay_id"
                                v-model="$store.state.settings.runtime.dontShowWhiteBackgroundInESesjaTvOverlay"
                                @change="updateDontShowWhiteBackgroundInESesjaTvOverlay()" />
                    </div>
                </section>
                <label class="esesja-modal__wraper__body__label" for="dontShowWhiteBackgroundInESesjaTvOverlay_id">{{$t('com.file.ui-element-settings.dont-show-white-background-in-esesjarv-overlay')}}</label>
            </section>
        </section>
        <section v-else class="component__body avatar">
            <section class="avatar__picture">
                {{$t('com.file.logo-settings.no-logo')}}
            </section>
        </section>

    </section>
</template>
<script charset="utf-8">
    import SettingsService from "@/services/settings.service";
    import AlertHelper from '@/helpers/alerts.helper.js';
    import { encryptStorage } from '@/services/encrypt.service';

    export default {
        name: "LogoSettings",
        components: {
        },
        data() {
            return {
                rawAvatar: '',
                showAvatarCropModal: false,
                logo: null,
                transmissionModule: encryptStorage.getItem('modules').tr,
            }
        },
        mounted() {
            SettingsService.getLogoClientImage().then((response) => {

                if (response.status !== 200) {
                    this.logo = null;
                }

                this.logo = response.data.image;

            }).catch(() => {
                this.logo = null;
            });
        },
        methods: {
            async deleteLogo() {
                try {
                    this.$store.commit("showLoader");

                    let response = await SettingsService.deleteLogoClientImage();
                    if (response.status !== 200) {
                        throw await Promise.reject(response)
                    }

                    this.logo = '';
                    this.$store.commit('setLogoBase64', '');
                }
                catch (e) {
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'logosettings' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.showAvatarCropModal = false;
                    this.$store.commit("hideLoader");
                }
            },
            async updateAvatar() {
                try {
                    this.$store.commit("showLoader");
                    
                    let request = {
                        image: this.rawAvatar,
                        userId: 0
                    }

                    let response = await SettingsService.setLogoClientImage(request);
                    if (response.status !== 200) {
                        throw await Promise.reject(response)
                    }

                    this.logo = this.rawAvatar;
                    this.$store.commit('setLogoBase64', this.rawAvatar);
                }
                catch (e) {
                    if (e.response.status == 404) {
                        this.$router.push({ name: 'notfoundpage', params: { pathMatch: 'logosettings' } });
                    }
                    else if (e.response.status == 401) {
                        this.$router.push({ name: 'Login' })
                    }
                }
                finally {
                    this.showAvatarCropModal = false;
                    this.$store.commit("hideLoader");
                }
            },
            selectAvatar() {
                let input = document.createElement('input');
                input.type = 'file';
                input.accept = '.png';
                input.multiple = false;
                input.click();
                input.addEventListener('change', event => {
                    if (event.target.files.length == 0)
                        return;

                    let proposedFile = event.target.files[0];
                    if (proposedFile.size > 10000000) {
                        this.$swal(AlertHelper.errorAlert(this.$t('com.validation-error.invalid-file-size-info') + " 10MB", this.$t('com.global.error')));
                        return;
                    }

                    if (!this.checkMimeType(proposedFile.type)) {
                        this.$swal(AlertHelper.errorAlert(this.$t('com.validation-error.invalid-file-type-info') + " PNG", this.$t('com.global.error')));
                        return;
                    }

                    let reader = new FileReader();
                    reader.readAsDataURL(proposedFile);
                    reader.onload = e => {
                        this.rawAvatar = e.target.result;
                        if (this.rawAvatar.length > 0) {
                            this.updateAvatar();
                        }
                    }
                });
            },
            checkMimeType(type) {
                if (type != "image/png") {
                    return false;
                } else {
                    return true;
                }
            },

            async updateDontShowWhiteBackgroundInESesjaTvOverlay() {
                try {
                    this.$store.commit("showLoader");
                    let data = { ...this.$store.state.settings.runtime };
                    data.dontShowWhiteBackgroundInESesjaTvOverlay = this.$store.state.settings.runtime.dontShowWhiteBackgroundInESesjaTvOverlay;

                    await this._internalUpdateData(data);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            },
            async _internalUpdateData(data) {
                return await SettingsService.updateClientSettings(data);
            },
        }
    }
</script>
<style lang="scss" scoped>
    @use "@/assets/scss/user-profile-component.scss";

    .component {
        width: 400px;
        height: fit-content;
    }

    .avatar {
        display: flex;
        flex-direction: column;
        row-gap: 20px;
        padding: 15px 20px;
        align-items: center;
        justify-content: center;

        &__picture {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &__img {
                max-width: 250px;
            }
        }

        &__actions {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }

    .avatar-info {
        display: flex;
        flex-direction: column;
        row-gap: 10px;

        &__item {
            display: flex;
            flex-direction: row;
            column-gap: 10px;
            padding: 10px;
            text-align: center;

            &__label {
                font-weight: 800;
            }
        }

        &__item2 {
            display: flex;
            flex-direction: row;
            column-gap: 5px;
            padding: 5px;
            text-align: center;
        }
    }

</style>